import React from "react";
import AppErrorFallback from "@/components/AppErrorFallback";

type RootErrorFallbackProps = {
  error?: unknown;
};

export default function RootErrorFallback({ error }: RootErrorFallbackProps) {
  React.useEffect(() => {
    if (!error) return;
    void import("@sentry/react").then((Sentry) => {
      Sentry.captureException(error, {
        tags: {
          route_error_boundary: "root",
        },
      });
    });
  }, [error]);

  return (
    <AppErrorFallback
      title="Unable to connect"
      description="We could not connect to the server. Please check your network or refresh to try again."
      actionLabel="Retry"
      enableVersionCheck
      error={error}
      onAction={() => window.location.reload()}
    />
  );
}
